import { render } from "./ZdfFooter.vue?vue&type=template&id=67e19e67"
import script from "./ZdfFooter.vue?vue&type=script&lang=js"
export * from "./ZdfFooter.vue?vue&type=script&lang=js"

import exportComponent from "J:\\20_Mitarbeiter\\Christian\\240626_Logo_Europa_Babylon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__